import React from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Anchor,
  Flex,
  Card,
  CardMedia,
} from "@ebscois/react-component-library";
import {
  StyledHeading,
  RightRailImageAnchor,
  StyledCardContent,
} from "./_.styled";
import { useBaseMediaUrls } from "../../hooks/useBaseMediaUrls";
import { getImageUrl, transformations } from "../../util/get-url-utils";
import {
  THUMB_SMALL,
  THUMB_MEDIUM,
  THUMB_LARGE,
} from "../../constants/image-sizes";
import ViewInContextMenu from "../ViewInContextMenu";

const ContentRightRailImage = ({
  label,
  images = [],
  handleOpenLightBoxImage,
  testId,
  slugTitle,
  slugPubType,
  isMobileDevice,
  isTabletDevice,
}) => {
  const { pathname: curSlugUrl } = useLocation();
  const cloudinaryUrl = useBaseMediaUrls("images");
  const image = images[0];

  return (
    <div data-testid={testId}>
      {images.length && (
        <>
          <Flex container justify={{ content: "space-between" }}>
            <StyledHeading element="h2" styledAs="h5" fontFamily="primary">
              {label}
            </StyledHeading>
            <Anchor
              linkComponent={Link}
              href={`${curSlugUrl}/images`}
              aria-label={`All images (${images.length})`}
            >
              All ({images.length})
            </Anchor>
          </Flex>

          <Card borderColor="gray400" borderStyle="solid" borderWidth="1px">
            <RightRailImageAnchor
              data-auto="rightrail-image-anchor"
              data-testid="right-rail-image-anchor"
              onClick={(e) => {
                e.preventDefault();
                handleOpenLightBoxImage();
              }}
            >
              <CardMedia
                borderYColor="gray400"
                borderYStyle="solid"
                borderYWidth="1px"
                data-element="rightrail-media-image-card"
                data-testid="right-rail-image"
                showFullscreenButton={false}
              >
                <img
                  alt={image.title}
                  src={getImageUrl(
                    image.publicId,
                    cloudinaryUrl,
                    transformations.small
                  )}
                  style={{ maxWidth: "inherit", maxHeight: "inherit" }}
                  srcSet={`${getImageUrl(
                    image.publicId,
                    cloudinaryUrl,
                    transformations.small
                  )} ${THUMB_SMALL}, ${getImageUrl(
                    image.publicId,
                    cloudinaryUrl,
                    transformations.medium
                  )} ${THUMB_MEDIUM}, ${getImageUrl(
                    image.publicId,
                    cloudinaryUrl,
                    transformations.large
                  )} ${THUMB_LARGE}`}
                />
              </CardMedia>
            </RightRailImageAnchor>
            <StyledCardContent>
              <Anchor
                data-auto="rightrail-image-title"
                data-testid="right-rail-image-title"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenLightBoxImage();
                }}
              >
                {image.title}
              </Anchor>
              {image?.associatedTopics &&
                ViewInContextMenu({
                  associatedTopics: image.associatedTopics,
                  slugTitle,
                  slugPubType,
                  isRightRail: true,
                  isMobileDevice,
                  isTabletDevice,
                })}
            </StyledCardContent>
          </Card>
        </>
      )}
    </div>
  );
};

ContentRightRailImage.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      copyright: PropTypes.string,
      publicId: PropTypes.string,
      title: PropTypes.string.isRequired,
    }).isRequired
  ),
};

ContentRightRailImage.displayName = "ContentRightRailImage";

export default ContentRightRailImage;
